import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.catalogos.comercioexterior_fraccion_arancelaria = {
      ...state.app.catalogos.comercioexterior_fraccion_arancelaria,
      filters: {
        ...state.app.catalogos.comercioexterior_fraccion_arancelaria.filters,
        ...meta,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.catalogos.comercioexterior_fraccion_arancelaria;

    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      page: meta.page || 1,
    };

    const response = await Http.get('catalogos/comercio-exterior-fraccion-arancelaria', { params });

    store.setState((state) => {
      state.app.catalogos.comercioexterior_fraccion_arancelaria = {
        ...state.app.catalogos.comercioexterior_fraccion_arancelaria,
        busy: false,
        data: response.data,
        pagination: {
          ...state.app.catalogos.comercioexterior_fraccion_arancelaria.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.catalogos.comercioexterior_fraccion_arancelaria.busy = false;
      state.app.catalogos.comercioexterior_fraccion_arancelaria.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.catalogos.comercioexterior_fraccion_arancelaria = {
      ...initialState,
    };
  });
};

const ComercioExteriorFraccionArancelariaSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default ComercioExteriorFraccionArancelariaSuggestionsStore;
